/*
  The mega menu's behaviour.

  Click is the interaction; hover is a convenience on top of it. NN/g's menu checklist is
  explicit that hover-only submenus are unavailable to touch and keyboard users, so the
  trigger is a real link that opens its panel on the first click and follows through to the
  category page on the second. Keyboard users get the same thing for free, since Enter on a
  focused link fires a click.

  The hover timing is theirs too: wait 0.5s before opening, so a pointer crossing the bar on
  its way somewhere else does not set the screen flickering, and wait 0.5s before closing,
  which covers the diagonal path from a trigger into its own panel.

  Escape closes and puts focus back on the trigger, a click outside closes, and moving to
  another trigger swaps panels immediately rather than waiting again.
*/
(() => {
  const OPEN_DELAY = 500;
  const CLOSE_DELAY = 500;

  const nav = document.querySelector('.atlas-nav');
  if (!nav) return;

  const items = [...nav.querySelectorAll('.atlas-nav__item')].filter((item) =>
    item.querySelector('[data-atlas-nav-panel]')
  );
  if (!items.length) return;

  let openItem = null;
  let openTimer = null;
  let closeTimer = null;

  const panelOf = (item) => item.querySelector('[data-atlas-nav-panel]');
  const triggerOf = (item) => item.querySelector('[data-atlas-nav-trigger]');

  const close = (item) => {
    if (!item) return;
    panelOf(item).hidden = true;
    triggerOf(item).setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
    if (openItem === item) openItem = null;
  };

  const open = (item) => {
    if (openItem && openItem !== item) close(openItem);
    panelOf(item).hidden = false;
    triggerOf(item).setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
    openItem = item;
  };

  const clearTimers = () => {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
  };

  items.forEach((item) => {
    const trigger = triggerOf(item);

    trigger.addEventListener('click', (event) => {
      // Second click on an open category goes to the category page, which is what the
      // link says it does. The first opens the panel instead.
      if (item.classList.contains('is-open')) return;
      event.preventDefault();
      clearTimers();
      open(item);
    });

    item.addEventListener('mouseenter', () => {
      clearTimers();
      // A panel is already open, so the shopper is reading the bar: swap without the wait.
      if (openItem) {
        open(item);
        return;
      }
      openTimer = setTimeout(() => open(item), OPEN_DELAY);
    });

    item.addEventListener('mouseleave', () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => close(item), CLOSE_DELAY);
    });

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) close(item);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !openItem) return;
    const trigger = triggerOf(openItem);
    close(openItem);
    trigger.focus();
  });

  document.addEventListener('click', (event) => {
    if (openItem && !openItem.contains(event.target)) close(openItem);
  });
})();
